import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/admin',
    name: 'AdminLogin',
    component: () => import(/* webpackChunkName: "admin-login" */ '../views/admin/Login.vue')
  },
  {
    path: '/admin/dashboard',
    name: 'Admin',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/Dashboard.vue')
  },
  {
    path: '/shop',
    name: 'Shop',
    component: () => import(/* webpackChunkName: "shop" */ '../views/shop/Home.vue')
  },
  {
    path: '/shop/verify-success',
    name: 'ShopVerifySuccess',
    component: () => import(/* webpackChunkName: "shop-verify-success" */ '../views/shop/VerifySuccess.vue')
  },
  {
    path: '/user',
    name: 'User',
    component: () => import(/* webpackChunkName: "user" */ '../views/user/Home.vue')
  },
  {
    path: '/c/:code',
    name: 'Claim',
    component: () => import(/* webpackChunkName: "user" */ '../views/user/Home.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/admin/dashboard')) {
    const token = localStorage.getItem('admin_token');
    if (!token) {
      next('/admin');
      return;
    }
  }
  next();
});

export default router;
